// extracted by mini-css-extract-plugin
module.exports = {"regular-size":"branding_regular-size__dAOPD","inline-logo":"branding_inline-logo__ZC0eH","inline-text":"branding_inline-text__f8Thz"};